import { dscvrApi } from '@/shared/api';

export const useMatricaLinkStatusQuery = async () => {
  return dscvrApi.matrica.getMatricaLinkStatus();
};
